import { validateRut } from "@fdograph/rut-utilities";
import { Box } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import { AccessTime, CloudUpload, Bookmark, Delete, Search, Save, Favorite, } from '@material-ui/icons';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const clean = rut => {
    return typeof rut === "string"
        ? rut.replace(/^0+|[^0-9kK]+/g, "").toLowerCase()
        : "";
}
export const cleanRut = clean;

export const validate = rut => validateRut(rut)

export const validatePrintCertificate = tramite => {
    if (!tramite.printCertificate || !tramite.fase) {
        return false
    }
    return true;
}

export const format = rut => {
    rut = clean(rut)

    var result = rut.slice(-4, -1) + "-" + rut.substr(rut.length - 1)
    for (var i = 4; i < rut.length; i += 3) {
        result = rut.slice(-3 - i, -i) + "." + result
    }

    return result
}


export const isAuthenticate = user => {
    if (user && user.access) {
        return true;
    }
    return false;
}

export const isAnalista = auth => {
    if (!auth) {
        return false
    }
    if (!auth.seguimiento) {
        return false
    }
    if (auth.seguimiento && auth.seguimiento.includes("view_all_tramites")) {
        return true
    }
    return false
}

export function process(date) {
    if (date !== undefined && date !== null) {
        var parts = date.split('/');
        return new Date(parts[2], parts[1] - 1, parts[0]);
    } else {
        let end = new Date()
        var dd = String(end.getDate()).padStart(2, '0');
        var mm = String(end.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = end.getFullYear();
        end = dd + '/' + mm + '/' + yyyy;
        return end
    }

}

export const canMonitor = (user) => {

    let isMonitor = false
    user.auth.seguimiento.map((item, index) => {
        if (item === "monitoreo") {
            isMonitor = true
        }
    })
    return isMonitor

}

function remainingDays(start) {
    let end = new Date()
    var dd = String(end.getDate()).padStart(2, '0');
    var mm = String(end.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = end.getFullYear();
    end = mm + '/' + dd + '/' + yyyy;
    let auxStart = process(start)
    let auxEnd = new Date(end)
    let oneDay = 1000 * 60 * 60 * 24;
    let diffInTime = auxEnd.getTime() - auxStart.getTime();
    let diffInDays = Math.round(diffInTime / oneDay);

    if (diffInDays <= 10) {
        return '#27a803';
    }

    if (diffInDays > 10 && diffInDays <= 20) {
        return '#bdb111';
    }

    if (diffInDays > 20 && diffInDays <= 30) {
        return '#bd2d06';
    }

    if (diffInDays > 30) {
        return 'black';
    }
}

export const actionsMonitoreo = [

    { action: 'verDetalle', label: 'Ver Detalle', icon: <Search /> },
    { action: 'dejar_seguir', label: 'Dejar de monitorear', icon: <SearchOffIcon /> },

];

export const actionsHistorico = [

    { action: 'verDetalle', label: 'Ver Detalle', icon: <Search /> },
    { action: 'monitorear', label: 'Volver a monitorear', icon: <SavedSearchIcon /> },

];

export const actionsSeguimientoNoMonitor = [
    { action: 'verDetalle', label: 'Ver Detalle', icon: <Search /> },
];
export const actionsSeguimiento = [

    { action: 'verDetalle', label: 'Ver Detalle', icon: <Search /> },
    { action: 'monitorear', label: 'Monitorear', icon: <SavedSearchIcon /> },
    { action: 'dejar_seguir', label: 'Dejar de monitorear', icon: <SearchOffIcon /> },

];

export const validacionesSeguimiento = [
    {
        type: 'dateRange',
        target: 'fechaIngreso',
        title: 'Fecha',
    },
];

export const tableHeadCells = [
    { id: 'folio', numeric: false, disablePadding: false, align: 'left', alignContent: 'left', label: 'Folio', },
    { id: 'nombre_solicitante', alignContent: 'left', label: 'Reclamante/Solicitante' },
    { id: 'fecha_ingreso', alignContent: 'left', label: 'Fecha Ingreso' },
    { id: 'rut_reclamante', alignContent: 'left', label: 'Rut' },

    { id: 'tramitacion', alignContent: 'left', label: 'Tipo trámite' },
    { id: 'reclamado', alignContent: 'left', label: 'Entidad' },

    { id: 'etapa_actual_tabla', alignContent: 'left', label: 'Etapa' },
    { id: 'fecha_esperada_termino', alignContent: 'left', label: 'Fecha Etapa' },
    { id: 'resultado', alignContent: 'left', label: 'Resultado' },

];

export const tableHeadCellsSeguimiento = [
    { id: 'folio', numeric: false, disablePadding: false, align: 'left', alignContent: 'left', label: 'Folio', },
    { id: 'nombre_solicitante', alignContent: 'left', label: 'Reclamante/Solicitante' },
    { id: 'fecha_ingreso', alignContent: 'left', label: 'Fecha Ingreso' },
    /*     { id: 'run_rec', alignContent: 'left', label: 'Rut' }, */
    { id: 'tramitacion', alignContent: 'left', label: 'Tipo trámite' },
    { id: 'reclamado', alignContent: 'left', label: 'Entidad' },
    { id: 'etapa_actual_tabla', alignContent: 'left', label: 'Etapa' },
    /*    { id: 'fecha_esperada_termino', alignContent: 'left', label: 'Fecha Etapa' }, */

];

export const getDatosReclamosList = (reclamo, isSeguimiento) => {

    let datos = {
        ...reclamo,
        isSeguimiento: isSeguimiento,
        monitoreo: reclamo.monitoreo,
        fechaIngreso: reclamo.fecha_ingreso !== null ? reclamo.fecha_ingreso.split('/').join('-') : null,
        vencimiento_raw: reclamo.fecha_esperada_termino, //aca va el dato crudo de la fecha de vencimiento /* fecha_etapa */
        nombre_solicitante: <div style={{ color: 'blue' }}>{reclamo.nombre_solicitante}</div>,
        nombre_raw: reclamo.nombre_solicitante,
        etapa_actual: reclamo.fase.nombre,
        fecha_etapa: reclamo.fecha_etapa,
        etapa_actual_tabla: (
            <div
                style={{
                    color: 'blue',
                    backgroundColor: 'skyblue',
                    fontWeight: 'bold',
                    display: 'inline-block',
                    borderRadius: '5px',
                    paddingLeft: 5,
                    paddingRight: 5,
                }}>
                {reclamo.fase.nombre}
            </div>
        ),
        fecha_esperada_termino: (
            <Tooltip title={reclamo.fecha_etapa ? 'Ingreso: ' + reclamo.fecha_ingreso + ' última modificacion: ' + reclamo.fecha_etapa : 'no ha sido modificado'}>
                <Box
                    sx={{
                        display: 'inline-flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    style={{
                        backgroundColor: reclamo.fecha_etapa ? remainingDays(reclamo.fecha_etapa) : 'grey',/* cambiar por fecha_etapa */
                        borderRadius: 25,
                        color: 'white',
                        paddingLeft: 10,
                        paddingRight: 10,
                        fontSize: 12,
                    }}>
                    <div
                        style={{
                            lineHeight: 1.5,
                            verticalAlign: 'middle',
                            display: 'inline',
                        }}>
                        {reclamo.fecha_etapa ? reclamo.fecha_etapa : null}
                    </div>
                    <div>
                        <AccessTime style={{ color: 'white', marginLeft: 2, marginTop: 2 }} />
                    </div>
                </Box>
            </Tooltip>
        ),
    };

    return datos;
};

export const ordenarFechas = (arr) => {

    let auxArr = arr.sort(function (a, b) {

        let fecha1 = process(a.fecha_etapa)
        let fecha2 = process(b.fecha_etapa)
        return fecha1 - fecha2
    })

    return auxArr
}

export const sinResultados = () => {
    return (
        <div style={{marginTop:40}}>
            <h3> No se encontraron resultados</h3>
        </div>
    )
}